module.exports = __webpack_public_path__ + "static/NotoSans-Light-557e1db0155c3f42f2c42c80460ed989.woff2";